import { br } from './bruQuery.js';
import { videoResize } from './videoResize.js';
import Swiper from 'swiper/dist/js/swiper.min.js';
import Barba from 'barba.js/dist/barba.min.js';
import TweenLite from 'gsap/src/minified/TweenMax.min.js';
import ScrollToPlugin from 'gsap/src/minified/plugins/ScrollToPlugin.min.js';
import Hammer from 'hammerjs';

//////////////////////////////////////////////////////////////////

var app = {
	swipers: false,
	scrollPosition: 0,
	namespace: 'homepage',
};

function orientation() {
	return Math.ceil(window.innerWidth/window.innerHeight);
};

function tablet() {
	return window.innerWidth <= 768 || orientation() == 1 ? true : false;
};

function desktop() {
	return window.innerWidth > 768 && orientation() == 2 ? true : false;
};

var forEach = function(array, callback) {
	for (var i = 0; i < array.length; i++) {
		callback(array[i], i);
	};
};


function activenav() {
	var sub = location.pathname.split("/")[2],
		currOne = window.location.protocol + "//" + window.location.host + "/" + location.pathname.split("/")[1],
		currentTwo = window.location.protocol + "//" + window.location.host + "/" + location.pathname.split("/")[1] + "/" + location.pathname.split("/")[2],
		current = typeof sub == 'undefined' ? currOne : currentTwo,
		navs = br('.menu-link');

	navs.for(function(nav) {
		if (nav.href == current) br(nav).addCls('active');
		else br(nav).rmCls('active');
	});
};

// Swipers
function swipers(where) {
	app.swipers = [];

	var swiperCovers = where.querySelectorAll('#fade-swiper');
	if (swiperCovers.length > 0) {
		br(swiperCovers).for(function(el) {
			var swiper = new Swiper(el, {
				effect: 'fade',
				speed: 1200,
				loop: true,
				preventClicks: false,
				preventClicksPropagation: false,
				autoplay: {
					delay: 3000,
				},
				on: {
					init: function() {
						if (viderResizer) viderResizer.update();
						el.addEventListener('click', function() {
							if (window.innerWidth > 767) {
								swiper.slideNext();
							}
						});
					},
					slideChange: function () {
						if (viderResizer) viderResizer.resize();
					},
				}
			});
			app.swipers.push(el);
		});
	};

	var swiperImages = where.querySelectorAll('#swiper');
	if (swiperImages.length > 0) {
		br(swiperImages).for(function(el) {
			var swiper = new Swiper(el, {
				effect: 'slide',
				speed: 800,
				navigation: {
					nextEl: el.querySelector('#image-slide-right'),
					prevEl: el.querySelector('#image-slide-left'),
				},
			});
			app.swipers.push(el);
		});
	};

	window.addEventListener("orientationchange", function(event) {
		forEach(app.swipers, function(el) { 
			setTimeout(function() {
				el.swiper.update();
				if (viderResizer) viderResizer.update();
			}, 100);
		});
	}, false);
};

function hoverTags() {
	var tags = br('.image-tag'),
		inTags = br('.image-tag .image-tag-image');

	tags.for(function(tag) {
		br(tag).hover(function(event) {
			var tagImgUrl = tag.dataset.imgUrl,
				tagImgWrap = tag.querySelector('.image-tag-image'),
				img = tagImgWrap.querySelector('img');

			if (!img) tagImgWrap.innerHTML += '<img src="'+tagImgUrl+'">';
		});

		function setCoordinats() {
			var tagImgUrl = tag.dataset.imgUrl,
				tagImgWrap = tag.querySelector('.image-tag-image'),
				tagRect = tag.getBoundingClientRect(),
				imgRect = tagImgWrap.getBoundingClientRect();

			if (event.clientX+400 >= window.innerWidth) {
				tagImgWrap.style.left = window.innerWidth - 400 + 'px';
			}
			else {
				tagImgWrap.style.left = event.clientX + 'px';
			};

			if (event.clientY+400 >= window.innerHeight) {
				tagImgWrap.style.top = window.innerHeight - 400 + 'px';
			}
			else {
				tagImgWrap.style.top = event.clientY + 'px';
			};
		};

		tag.addEventListener('mousemove', function(event) {
			if (window.innerWidth >= 1024) {
				setCoordinats();
			};
		});

		tag.addEventListener('click', function(event) {
			if (window.innerWidth < 1024 && event.target == tag) {
				setCoordinats();
				tags.rmCls('show');
				br(tag).addCls('show');
			};
		});
	});

	inTags.click(function(event) {
		var tag = br(event.target).closest('.image-tag');
		br(tag).rmCls('show');
	});
};

// MENUS
var menuController = function() {
	var _this = this,
		menu = br('.nav'),
		menuFirst = br('.nav-one'),
		menuInner = br('.nav-two, .nav-three'),
		overlay = br('.overlay'),
		
		triger = br('.menu-triger'),
		innerLinks = br('.nav-two .menu-link'),
		menuTrigers = br('.inn-menu'),
		countryLinks = br('.country-link'),

		closeOne = br('.menu-close'),
		closeTwo = br('.inner-close');

	this.openFirst = function(noOver) {
		menu.addCls('open').rmCls('hide').rmCls('hide-mobile');
		menuInner.rmCls('open').addCls('hidden');
		if (window.innerWidth <= 768) {
			menuInner.addCls('show');
		} else {
			setTimeout(function() {
				br(menuInner.$[0]).addCls('show');
			}, 800);
		};

		if (!noOver) {
			overlay.addCls('open');
			br(document.body).addCls('open');
		};
	};

	this.hideFirst = function() {
		menuInner.rmCls('hidden');
		if (window.innerWidth > 768) {
			menu.addCls('hide');
		} else {
			menuInner.rmCls('show').rmCls('open');
			menu.rmCls('hide').rmCls('open');
			overlay.rmCls('open');
			br(document.body).rmCls('open');
		};
	};

	this.openSecond = function(menus, trig) {
		var targetMenu = br(menus);
		
		if (targetMenu.hasClass('open') && trig) {
			targetMenu.rmCls('open').addCls('hidden');
		} else {
			targetMenu.addCls('open').rmCls('hidden');
			setTimeout(function() {
				targetMenu.addCls('show');
			}, 50);
		};

		menuInner.for(function(inner) {
			if (inner != targetMenu.first) {
				br(inner).rmCls('open').rmCls('show').addCls('hidden');
			};
		});

		if (window.innerWidth <= 768) {
			menu.addCls('hide-mobile');
		};
		if (!menu.hasClass('open')) {
			menu.addCls('open');
			if (menus != '.nav-three') menu.addCls('hide')
		};
	};

	this.hideSecond = function() {
		menu.rmCls('hide').rmCls('hide-mobile');
		menuInner.rmCls('open').addCls('show');
		menuTrigers.rmCls('active');
		setTimeout(function() {
			menuInner.addCls('hidden');
		}, 20);
	};

	this.closeMenus = function() {
		menu.rmCls('open').rmCls('hide').rmCls('hide-mobile');
		menuInner.rmCls('open').rmCls('hide').rmCls('show').rmCls('hidden');
		overlay.rmCls('open');
		br(document.body).rmCls('open');
	};

	this.menuTrig = function() {
		if (menu.hasClass('open')) {
			this.closeMenus();
		} else {
			this.openFirst();
		};
	};

	var menuSwipe = new Hammer(menuFirst.first);
	menuSwipe.on('swipeleft', function(event) {
		if (app.namespace == 'products' || app.namespace == 'contact') {
			if (window.innerWidth <= 768) {
				_this.closeMenus();
			}
		} else {
			_this.closeMenus();
		};
		
	});

	menuInner.for(function(inner) {
		var innerSwipe = new Hammer(inner);

		innerSwipe.on('swipeleft', function(event) {
			if (app.namespace == 'products' || app.namespace == 'contact') {
				if (window.innerWidth <= 768) {
					_this.closeMenus();
				}
			} else {
				_this.closeMenus();
			};
		});
		innerSwipe.on('swiperight', function(event) {
			if (br(inner).hasClass('open')) {
				_this.hideSecond();
			};
		});
	});

	closeOne.click(function(event) {
		if (event.target == closeOne.first) {
			 _this.closeMenus();
		};
	});

	closeTwo.for(function(close) {
		close.addEventListener('click', function(event) {
			if (event.target == close) {
				_this.hideSecond();
			};
		});
	});

	menuFirst.click(function(event) {
		if (menu.hasClass('hide')) {
			_this.hideSecond();
		};
	});

	menuInner.for(function(menus) {
		menus.addEventListener('click', function() {
			if (br(menus).hasClass('hidden')) {
				_this.openSecond(menus);
			};
		});
	});

	countryLinks.click(function(event) {
		if (window.innerWidth <= 768) {
			_this.closeMenus();
		};
	});

	overlay.click(function() {
		_this.closeMenus();
	});

	innerLinks.click(function() {
		_this.hideFirst();
	});

	menuTrigers.for(function(menuTriger) {
		br(menuTriger).click(function(evevnt) {
			br(menuTriger).toCls('active');

			menuTrigers.for(function(menuTrig) {
				if (menuTrig != evevnt.target) br(menuTrig).rmCls('active');
			});

			_this.openSecond(menuTriger.dataset.menu, true);
		});
	});
};

function menuPageTrigers(f) {
	var triger = br('.menu-triger'),
		specsTrig = br('.specs-trig'),
		specs = br('.product-images');
		//specsBott = specs.first ? specs.first.getBoundingClientRect().bottom : false;

	triger.click(function() {
		if (f) f.menuTrig();
	});

	if (specsTrig.length && specs.length) {

		specsTrig.click(function() {
			if (window.innerWidth > 768) {
				specs.toCls('hide');
				specsTrig.toCls('active');
			} else {
				var specScroll = specs.first.getBoundingClientRect().bottom;
				console.log(specScroll);
				TweenLite.to(window, 0.8, {
					scrollTo: specScroll,
					autokill: false,
					ease: Power2.easeOut,
				});
			};
		});

		specs.click(function() {
			if (window.innerWidth > 768) {
				specs.rmCls('hide');
				specsTrig.rmCls('active');
			};
		});
	};
};

function forms() {
	var enquireForm = br('.enquire-form'),
		mess = document.querySelector('.form-message'),
		signUpTrigger = br('.sign-up-triger'),
		signUpWrap = br('.footer'),
		signUpClose = br('.sign-up-close'),
		signUpTitle = br('.sign-up-title').first,
		signUpForm = br('#sign-up-form'),
		formButton = br('button[type="submit"]');

	var before1 = function(form) {
		mess.innerHTML = 'Sending...'
		formButton.first.setAttribute('disabled','');
	};

	var after1 = function(response) {
		var messR = response.querySelector('.form-message');
		mess.innerHTML = messR.innerHTML;
		enquireForm.first.reset();
		formButton.first.removeAttribute('disabled');
	};

	enquireForm.ajaxForm(before1, after1, true);

	var before2 = function(form) {
		signUpTitle.innerHTML = 'Subscribing...';
	};

	var after2 = function(response) {
		signUpTitle.innerHTML = 'Done. Thanks ;)';
		setTimeout(function() {
			signUpTitle.innerHTML = 'Email Newsletter';
			signUpWrap.rmCls('open');
			signUpTrigger.rmCls('active');
		}, 3000);
	};

	signUpForm.ajaxForm(before2, after2);

	signUpTrigger.click(function() {
		signUpWrap.toCls('open');
		signUpTrigger.toCls('active');
	});

	signUpClose.click(function() {
		signUpWrap.rmCls('open');
		signUpTrigger.rmCls('active');
		signUpForm.first.reset();
	});
};

// google maps
function initMap() {
	var center, map = document.getElementById('map');
	if (google && map) {
		var pos = window.cultureMapLat ? new google.maps.LatLng(window.cultureMapLat, window.cultureMapLng) : {lat: -36.8458431, lng: 174.7629076};
		var mapContact = new google.maps.Map(document.getElementById('map'), {
			center: pos,
			zoom: window.cultureMapZoo ? window.cultureMapZoo : 5,
			disableDefaultUI: true,
			draggable: true,
			zoomControl: true,
			scrollwheel: true,
			styles: [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]
		});

		var markerIcon = {
			path: "M16, 16 m -16, 0 a 16,16 0 1,0 32,0 a 16,16 0 1,0 -32,0",
			fillColor: '#595c58',
			fillOpacity: 1,
			anchor: new google.maps.Point(16, 16),
			strokeWeight: 0,
			scale: 1
		};

		if (window.cultureMapLat)
			var mapMarker = new google.maps.Marker({
				position: pos,
				map: mapContact,
				draggable: false,
				icon: markerIcon,
			});
		
		google.maps.event.addListener(mapContact, 'idle', function() {
			center = mapContact.getCenter();
		});

		google.maps.event.addDomListener(window, 'resize', function() {
			google.maps.event.trigger(mapContact, 'resize');
			mapContact.setCenter(center);
		});			
	};
};


var menus = false;
var viderResizer = false;
function init() {
	br('.curtain').rmCls('open');
	activenav();
	br().inputs();
	hoverTags();
	forms();

	if (menus) {
		menuPageTrigers(menus);
		if (app.namespace == 'products' && window.innerWidth > 768) {
			menus.openSecond('.nav-two');
		} else if (app.namespace == 'stockists' && window.innerWidth > 768) {
			menus.openSecond('.nav-three');
		} else if (app.namespace == 'contact' && window.innerWidth > 768) {
			menus.openFirst(true);
		};
	};
};

document.addEventListener("DOMContentLoaded", function() {
	app.namespace = br('.barba-container').first.id;

	menus = new menuController();
	viderResizer = new videoResize('.has-cover-video');
	swipers(document);
	init();

	window.addEventListener('resize', function() {
		viderResizer.resize();
	
		if (window.innerWidth > 768) {
			if (app.namespace == 'products') {
				menus.openSecond('.nav-two');
			} else if (app.namespace == 'stockists') {
				menus.openSecond('.nav-three');
			} else if (app.namespace == 'contact') {
				menus.openFirst(true);
			} else {
				menus.closeMenus();
			};
		} else {
			menus.closeMenus();
			if (app.namespace == 'product' && window.innerWidth <= 768) document.body.style.cssText = 'height: initial';
			else document.body.style.cssText = 'height: 100%';
		};

		br('.sign-up-triger').rmCls('active');
		br('.footer').rmCls('open');
	});

	////////////// BARBA //////////////

	var contact = Barba.BaseView.extend({
	namespace: 'contact',
		onEnter: function() { 
			var noMap = true;
			br('script').for(function(el) { if (el.src.indexOf('maps.googleapis.com') != -1) noMap = false; });
			if (noMap) br().loadScript('https://maps.googleapis.com/maps/api/js?key=AIzaSyBSRaoF70YRW5WWwWGsmjt7UU7lW1bNgIg', initMap);
			else initMap();
		},
	});

	contact.init();

	// BARBA INIT	
	Barba.Pjax.init();
	Barba.Prefetch.init();

	//SAME LINK CLICK FIX
	forEach(document.querySelectorAll('.nav a'), function(el) {
		el.addEventListener('click', function(lnk){
			var link = lnk.target.closest('a');
			if(link.href === window.location.href) {
				lnk.preventDefault(); lnk.stopPropagation();
			};
		});
	});

	var transition = Barba.BaseTransition.extend({
		start: function() {	
			Promise
				.all([this.newContainerLoading, this.fadeOut()])
				.then(this.fadeIn.bind(this));
		},

		fadeOut: function() {
			var deferred = Barba.Utils.deferred();
			br('.curtain').addCls('open');

			setTimeout(function() {
				deferred.resolve();

				br('.mobile-nav').rmCls('open');

			}, 600)
			return deferred.promise;
		},

		fadeIn: function() {
			window.scrollTo(0, 0);
			this.done();
		},
	});

	Barba.Pjax.getTransition = function() { return transition };

	Barba.Dispatcher.on('linkClicked', function(HTMLElement, MouseEvent) {
		if 		  (MouseEvent.target.classList.contains('products-link') && window.innerWidth > 768) {
		} else if (MouseEvent.target.classList.contains('contact-link') && window.innerWidth > 768) {
		} else if (MouseEvent.target.classList.contains('country-link') && window.innerWidth > 768) {
		} else {
			if (menus) menus.closeMenus();
		};

		br('.overlay').rmCls('open');
	});

	Barba.Dispatcher.on('newPageReady', function(currentStatus, prevStatus, newCont, newFullpage) { 
		app.namespace = currentStatus.namespace;
		br().JSrun(newCont);
		swipers(newCont);
	});

	Barba.Dispatcher.on('transitionCompleted', function(currentStatus) {
		init();
	});
});


// WEBPACK FOOTER //
// ./__dev/js/app.js